module.exports = __webpack_public_path__ + "img/small-remnants-ground-patch.3a36363e.png";